/* AH Design 3 Nov v1.2: on touch phones, touching a product card image shows its second (lifestyle) image, like the desktop hover. A tap still opens the product. The card stays flipped until another card is touched. */
(function(){
  if(!window.matchMedia||!window.matchMedia('(hover: none)').matches) return;
  var last=null;
  function img(box){return box.querySelector('img.rimage__img');}
  function flip(box){
    if(box.getAttribute('data-ah-flip')==='1') return;
    var url=box.getAttribute('data-js-product-image-hover'); var im=img(box);
    if(!url||!im) return;
    var w=Math.min(1200,Math.round((box.clientWidth||300)*(window.devicePixelRatio||2)));
    var src=url.replace('{width}',String(w));
    var pre=new Image();
    pre.onload=function(){
      if(box!==last) return;
      box.setAttribute('data-ah-orig',im.currentSrc||im.src);
      box.setAttribute('data-ah-flip','1');
      im.removeAttribute('srcset'); im.src=src;
    };
    pre.src=src;
  }
  function unflip(box){
    if(!box||box.getAttribute('data-ah-flip')!=='1') return;
    var im=img(box); var o=box.getAttribute('data-ah-orig');
    if(im&&o){im.removeAttribute('srcset'); im.src=o;}
    box.removeAttribute('data-ah-flip');
  }
  document.addEventListener('touchstart',function(e){
    var t=e.target; if(!t||!t.closest) return;
    var box=t.closest('[data-js-product-image-hover]');
    if(!box) return;
    if(last&&last!==box) unflip(last);
    last=box; flip(box);
  },{passive:true});
})();
